import React from "react";

const DoorstepPickup = () => {
  return (
    <section className="bg-white text-black py-12 px-6 md:px-24 flex flex-col items-center text-center">
      
      {/* Heading */}
      <h2 className="text-3xl font-extrabold bg-gradient-to-r from-green-600 via-emerald-500 to-lime-400 bg-clip-text text-transparent">
        Premium Turf Solutions for Every Sport
      </h2>

      {/* Description */}
      <p className="text-lg md:text-xl mb-8 max-w-2xl text-gray-700">
        ZajraGreen delivers world-class sports turf installation with precision and
        long-lasting durability. From football grounds to box cricket arenas and
        multi-sport facilities, we provide complete design-to-installation solutions
        trusted across India.
      </p>

      {/* Image */}
      <div className="w-full flex justify-center">
        <img
          src="/images/turf-feature.jpg"  // Replace with your real image
          alt="Sports Turf Installation"
          className="w-full max-w-3xl h-auto rounded-xl shadow-lg object-cover"
        />
      </div>

    </section>
  );
};

export default DoorstepPickup;
